import React, { useState } from "react";
import {
    Button,
    CloseIcon,
    Dialog,
    Flex,
    Text,
} from "@fluentui/react-northstar";
import styled from "styled-components";
import SuperviseContent from "./SuperviseContent";
import { DEVICE } from "../../../../constants/responsive";

const Supervise = ({ header = "", users }) => {
    const [open, setOpen] = useState(false);
    const _openDialog = () => {
        setOpen(true);
    };
    const _closeDialog = () => {
        setOpen(false);
    };
    return (
        <DialogStyle
            open={open}
            onCancel={_closeDialog}
            header={header}
            headerAction={{
                icon: <CloseIcon />,
                onClick: _closeDialog,
            }}
            footer={{
                children: () => {
                    return (
                        <Flex hAlign="center" fill>
                            <Button
                                onClick={_closeDialog}
                                flat
                                primary
                                content="Fermer"
                            />
                        </Flex>
                    );
                },
            }}
            content={<SuperviseContent users={users} />}
            trigger={
                <TextLink
                    content="Voir tous les profils"
                    onClick={_openDialog}
                />
            }
        />
    );
};

export default Supervise;

const DialogStyle = styled(Dialog)`
    @media ${DEVICE.mobileS} {
        width: 90%;
    }
    @media ${DEVICE.tablet} {
        width: 390px;
    }
`;

const TextLink = styled(Text)`
    color: #6264a7;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    cursor: pointer;
`;
